/**
 * El comprobante de factura y la nota de crédito, validados en el cliente con
 * la misma allowlist y el mismo techo que el worker (ADR 0099 C2). El worker
 * revalida todo, incluidos los magic bytes: esto solo evita mandar 10 MB para
 * enterarse de que no servían.
 */

const EXTENSIONES = ["pdf", "jpg", "jpeg", "png"] as const;
const MIMES = ["application/pdf", "image/jpeg", "image/png"] as const;

export const MAXIMO_ARCHIVO_FISCAL = 10 * 1024 * 1024;

/** El `accept` del `<input type="file">`: filtra el selector, no valida. */
export const ACEPTA_ARCHIVO_FISCAL = [...EXTENSIONES.map((e) => `.${e}`), ...MIMES].join(",");

function extensionDe(nombre: string): string | null {
  const punto = nombre.lastIndexOf(".");
  if (punto <= 0 || punto === nombre.length - 1) return null;
  return nombre.slice(punto + 1).toLowerCase();
}

/** `null` si sirve; si no, el motivo para mostrar. */
export function validarArchivoFiscal(archivo: { name: string; size: number }): string | null {
  const extension = extensionDe(archivo.name);
  if (extension === null) return "El archivo no tiene extensión";
  if (!(EXTENSIONES as readonly string[]).includes(extension)) {
    return `Extensión no permitida: .${extension}. Se aceptan: ${EXTENSIONES.join(", ")}`;
  }
  if (archivo.size === 0) return "El archivo está vacío";
  if (archivo.size > MAXIMO_ARCHIVO_FISCAL) {
    const mb = (archivo.size / 1024 / 1024).toFixed(1);
    return `El archivo pesa ${mb} MB y el máximo es 10 MB`;
  }
  return null;
}
